import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import DataDeletion from './pages/DataDeletion';
import DeleteAccount from './pages/DeleteAccount';
import TenantPortal from './pages/TenantPortal';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/t/:slug" element={<TenantPortal />} />
          <Route path="/t" element={<Navigate to="/" replace />} />
          <Route path="/t/" element={<Navigate to="/" replace />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/pricing" element={<Navigate to="/" replace />} />
                  <Route path="/features" element={<Features />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/data-deletion" element={<DataDeletion />} />
                  <Route path="/delete-account" element={<DeleteAccount />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
